import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { FilesAndSuggestionsPluginService } from './filesandsuggestions-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { EditFileAndSuggestionMenuComponent } from '../../menus/index';
import { OfflineService } from '../../shared/services/offline-mode.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Inspection } from '../../shared/models';
import { FileContentService } from '../../shared/services/fileContent.service';
import { AnnotateModalComponent, EditImageModalComponent } from '../../shared/components';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'fileandsuggestion-edit',
    templateUrl: './fileandsuggestion-edit.component.html',
    standalone: false
})
export class FileAndSuggestionEditPageComponent extends BaseModalPageComponent implements OnInit, AfterViewInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  assetId: string;
  assetUrl: string;
  initialAssetUrl: string;
  public plugin: any;
  public inspection: Inspection;
  public comment: string;
  public type: number;
  public annotation: any;
  public annotationComments: any[];
  public svg: any;
  public fullWidth: boolean;
  editForm: UntypedFormGroup;
  public processing = false;
  public angle = 0;
  public types: any;
  private initComment: string;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('deleteFileConfirm', { static: true })
  deleteFileConfirm: ConfirmComponent;
  @ViewChild('image', { static: true })
  image: ElementRef;
  @ViewChild('imageEditModal', { static: true })
  imageEditModal: ModalComponent;
  @ViewChild('imageAnnotationModal', { static: true })
  imageAnnotationModal: ModalComponent;
  @ViewChild('typesModal', { static: true }) typeModal: ModalComponent;
  public menuComponent = EditFileAndSuggestionMenuComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: FilesAndSuggestionsPluginService,
    location: Location,
    private cdf: ChangeDetectorRef,
    private offline: OfflineService,
    private indexedDb: IndexedDbService,
    private sanitizer: DomSanitizer,
    private fileService: FileContentService
  ) {
    super(location);
    this.editForm = new UntypedFormGroup({});
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      const assetId = params['assetId'];
      if (assetId == null) this.goToBack();

      this.assetId = assetId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    const data = {
      comment: this.comment,
      annotation: this.annotation,
      annotationComments: this.annotationComments,
      svg: this.svg,
      type: this.type,
      settings: { fullWidth: this.fullWidth }
    };
    this.service
      .editComment(
        this.inspectionId,
        this.pointId,
        this.pluginId,
        this.assetId,
        data,
        this.assetUrl != this.initialAssetUrl ? this.assetUrl : null
      )
      .subscribe((data) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
    this.editForm = new UntypedFormGroup({});
  }

  ngAfterViewInit() {
    /*this.service.getEditedImagesIds().subscribe((ids) => {
      ids.forEach((id) => {
        if (this.image.nativeElement.src.includes(id)) {
          this.image.nativeElement.src = `${this.image.nativeElement.src}?v=${Date.now()}`;
        }
      });
    });*/
  }

  initData() {
    this.types = _.orderBy(this.service.getToTypes(), ['label']);
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.inspection = data.inspection;
      const comments = this.plugin.config.Comments;
      const annotations = this.plugin.config.Annotations;
      const svgs = this.plugin.config.Svgs;

      const types = this.plugin.config.Types;
      this.type = types && types[this.assetId] ? types[this.assetId] : -1;

      this.annotation = annotations && annotations[this.assetId] ? annotations[this.assetId] : null;
      this.svg = svgs && svgs[this.assetId] ? svgs[this.assetId] : null;
      this.comment = comments && comments[this.assetId] ? comments[this.assetId].replace(regex, '\n') : '';

      const annotationsComments = this.plugin.config.AnnotationsComments;
      this.annotationComments =
        annotationsComments && annotationsComments[this.assetId] ? annotationsComments[this.assetId] : null;

      const settings = this.plugin.config.Settings;
      const setting = settings && settings[this.assetId] ? settings[this.assetId] : null;
      this.fullWidth = setting?.FullWidth;

      this.initComment = this.comment;
      const localComment = this.service.getLocalComment(this.assetId);
      if (localComment) {
        this.comment = localComment;
        this.initComment = localComment;
      }
      this.cdf.detectChanges();
    });

    if (this.inspection.isOffline) {
      this.indexedDb
        .getImageUrl(this.assetId)
        .flatMap((url) =>
          this.fileService.loadFileContent(
            url.changingThisBreaksApplicationSecurity ? url.changingThisBreaksApplicationSecurity : url
          )
        )
        .subscribe((url) => {
          this.assetUrl = url;
          this.initialAssetUrl = url;
          this.updateSvgElement();
        });
    } else {
      this.fileService.loadFileContent(`/api/assets/${this.assetId}/content`).subscribe((url) => {
        this.assetUrl = url;
        this.initialAssetUrl = url;
        this.updateSvgElement();
      });
    }
  }

  changeCheckboxValue() {
    this.fullWidth = !this.fullWidth;
  }

  public openEditImage(): void {
    this.imageEditModal.modalFooter = false;
    this.imageEditModal.modalHeader = false;
    this.imageEditModal.modalMessage = false;
    this.imageEditModal.open(EditImageModalComponent, this.assetUrl);
  }

  public openAnnotateImage(): void {
    this.imageAnnotationModal.modalFooter = false;
    this.imageAnnotationModal.modalHeader = false;
    this.imageAnnotationModal.modalMessage = false;
    this.imageAnnotationModal.open(AnnotateModalComponent, {
      image: this.assetUrl,
      annotation: this.annotation,
      svg: this.svg
    });
  }

  public openTypesSelector(selectedIndex: number): void {
    this.openSelector(this.typeModal, this.types, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
  }

  public selectTypesMenu(item: any) {
    const selectedIndex = this.type === item.selectedIndex ? -1 : item.selectedIndex;
    this.type = selectedIndex;
  }

  public updateImage(data): void {
    this.assetUrl = data.image;
    this.updateSvgElement();
  }

  public updateImageAnnotation(data): void {
    this.annotation = data?.annotation;
    this.annotationComments = data?.annotationComments;
    this.svg = data?.svg;
    this.updateSvgElement();
  }

  public svgElement: SafeHtml;

  public updateSvgElement() {
    if (this.svg) {
      let svgToRender = this.svg.replace(/NS\d+:href=''/gi, `href="${this.assetUrl}"`);
      svgToRender = this.svg.replace(/ns\d+:href=""/gi, `href="${this.assetUrl}"`);
      const htmlData = this.sanitizer.bypassSecurityTrustHtml(svgToRender);
      this.svgElement = htmlData;
    }
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 2:
        this.openDeleteFileConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openDeleteFileConfirm() {
    this.deleteFileConfirm.open();
  }

  deletePlugin(e: any) {
    this.service
      .deleteFilesPlugin(this.inspectionId, this.pointId, this.pluginId, this.plugin.config.Assets)
      .subscribe((success: boolean) => {
        if (success) {
          this.goToBack();
        }
      });
  }

  rotate() {
    if (this.angle && this.angle === 270) {
      this.angle = 0;
    } else {
      this.angle += 90;
    }
  }

  deleteFile(e: any) {
    this.service.deleteFile(this.inspectionId, this.pointId, this.pluginId, this.assetId).subscribe((data) => {
      this.service.deleteLocalComment(this.assetId);
      this.goToBack();
    });
  }
}
